import React from "react";
import { Card } from "reactstrap";
import Thumbnails from "../cards/Thumbnails";

const RequestServiceInfoSection = ({ serviceName, requestStaffSummary, requestFiles }) => {

  return (
    <Card className="question d-flex mb-4">
      <div className="d-flex flex-grow-1 min-width-zero">
        <div className="card-body align-self-center d-flex flex-column flex-md-row 
        justify-content-between min-width-zero align-items-md-center">
          <div className="list-item-heading mb-0 truncate w-80 mb-1 mt-1" />
        </div>
      </div>

      <div className="card-body pt-0">
        <div className="edit-mode">
          {requestStaffSummary && requestStaffSummary.length >= 3 ? (
            <div>
              <h1 className="list-item-heading float-left w-25 mb-1">{serviceName}</h1>
              <div
                className="list-item-heading float-right w-70 mb-1"
                dangerouslySetInnerHTML={{ __html: requestStaffSummary ?? "" }}
              />
            </div>
          ) : (
            <div style={{ textAlign: "center" }}>
              <h1 className="list-item-heading w-100 mb-1">{serviceName}</h1>
            </div>
          )}
        </div>

        {requestFiles &&
          <div className="edit-mode">
            <h1 className="list-item-heading float-left w-25 mb-1">Files</h1>
            <div className="list-item-heading float-right w-70 mb-1">
              <Thumbnails items={requestFiles} />
            </div>
          </div>
        }
      </div>
    </Card>
  );
};

export default RequestServiceInfoSection;
